<div class="content">
    <div class="text-empty-state">{{ text }}</div>
</div>
